import React from 'react'
import PropTypes from 'prop-types'
import { injectIntl } from 'react-intl'
import FormattedMessage from '../../FormattedMessage/FormattedMessage'

const SelectInput = ({
  id,
  label,
  name,
  value,
  onBlur,
  onChange,
  placeholder,
  options,
  intl,
  required,
  'aria-required': ariaRequired,
  'aria-invalid': ariaInvalid,
  'aria-describedby': ariaDescribedBy,
}) => {
  const fieldId = id || name
  const isRequired = required || ariaRequired

  return (
    <div className={`amd-select-container ${!label ? 'amd-input-container-no-label' : ''}`}>
      <label className="form-label-sm" htmlFor={fieldId}>
        <FormattedMessage id={label} />
        {isRequired && (
          <span className="required-indicator" aria-hidden="true">
            *
          </span>
        )}
        {isRequired && <span className="sr-only">(required)</span>}
      </label>
      <select
        className="form-control amd-select"
        id={fieldId}
        name={name}
        value={value}
        onBlur={onBlur}
        onChange={onChange}
        placeholder={placeholder}
        required={isRequired}
        aria-required={isRequired}
        aria-invalid={ariaInvalid}
        aria-describedby={ariaDescribedBy}
      >
        {placeholder && (
          <option value="" disabled>
            {intl.formatMessage({ id: placeholder })}
          </option>
        )}
        {options &&
          options.map((option, index) => (
            <option key={`option-${index + 1}`} value={option.value}>
              {option.key ? intl.formatMessage({ id: option.key }) : option.label}
            </option>
          ))}
      </select>
    </div>
  )
}

SelectInput.propTypes = {
  intl: PropTypes.shape(),
  id: PropTypes.string,
  name: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      key: PropTypes.string,
      label: PropTypes.string,
    })
  ),
  required: PropTypes.bool,
  'aria-required': PropTypes.bool,
  'aria-invalid': PropTypes.bool,
  'aria-describedby': PropTypes.string,
}

export default injectIntl(SelectInput)
